import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function Hero({ felhasznalo }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);
    const reszecskek = Array.from({length: 80}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      r: Math.random() * 24 + 8, vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4,
      szin: ['#1a73e8','#34a853','#f9ab00','#ea4335','#9c27b0','#00bcd4'][Math.floor(Math.random()*6)],
      alpha: Math.random() * 0.12 + 0.04,
    }));
    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      reszecskek.forEach(r => {
        r.x += r.vx; r.y += r.vy;
        if (r.x < -r.r) r.x = canvas.width + r.r;
        if (r.x > canvas.width + r.r) r.x = -r.r;
        if (r.y < -r.r) r.y = canvas.height + r.r;
        if (r.y > canvas.height + r.r) r.y = -r.r;
        ctx.beginPath(); ctx.arc(r.x, r.y, r.r, 0, Math.PI * 2);
        ctx.fillStyle = r.szin + Math.floor(r.alpha * 255).toString(16).padStart(2, '0');
        ctx.fill();
      });
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);

const statisztikak = [
    { szam: '28', felirat: 'Interaktív lecke', ikon: '📚', szin: '#1a73e8' },
    { szam: '3', felirat: 'Korosztály', ikon: '👶', szin: '#34a853' },
    { szam: '100%', felirat: 'Ingyenes', ikon: '🎁', szin: '#f9ab00' },
    { szam: '∞', felirat: 'Kaland', ikon: '🚀', szin: '#9c27b0' },
  ];
  const lepesek = [
    {
      szam: '1', ikon: '📚', cim: 'Válassz leckét!',
      leiras: 'Válaszd ki a korodnak megfelelő korosztályt és nyisd meg az első leckét!',
      szin: '#1a73e8', haatter: 'linear-gradient(135deg, #e3f2fd, #f0f7ff)',
    },
    {
      szam: '2', ikon: '🎬', cim: 'Okosodj a témáról!',
      leiras: 'Azért legyél a témában jártas! Olvasd el az olvasmányt vagy nézd meg a videót!',
      szin: '#9c27b0', haatter: 'linear-gradient(135deg, #f3e5f5, #fce4ec)',
    },
    {
      szam: '3', ikon: '🎮', cim: 'Játssz és tanulj!',
      leiras: 'Oldd meg az interaktív feladatokat, gyűjts XP pontokat és válj igazi NetOkossá!',
      szin: '#34a853', haatter: 'linear-gradient(135deg, #e8f5e9, #f9fbe7)',
    },
  ];

  return (
    <>
      <style>{`
        .fooldal {
          background: linear-gradient(135deg, #f8f9ff 0%, #f0f7ff 50%, #f5f0ff 100%);
          position: relative;
          overflow: hidden;
        }
        .fooldal-canvas {
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          pointer-events: none;
          z-index: 0;
        }
        .hero {
          position: relative;
          z-index: 1;
          display: flex;
          align-items: center;
        }
   .hero-inner {
  max-width: min(1500px, 90vw);
  margin: 0 auto;
          padding: 2.5rem 2rem 2.5rem;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: center;
          width: 100%;
          box-sizing: border-box;
        }
        .hero-bal {
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        }
        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.8);
          backdrop-filter: blur(10px);
          border: 2px solid #e0e0e0;
          border-radius: 50px;
          padding: 8px 20px;
          font-size: 14px;
          font-weight: 700;
          color: #333;
          width: fit-content;
        }
        .hero-cim {
          font-size: 48px;
          font-weight: 900;
          line-height: 1.1;
          color: #1a1a2e;
          margin: 0;
        }
        .hero-cim span {
          background: linear-gradient(135deg, #1a73e8, #9c27b0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .hero-leiras {
          font-size: 18px;
          color: #555;
          line-height: 1.6;
          max-width: 480px;
          margin: 0;
        }
        .hero-gombok {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }
        .hero-fo-gomb {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 16px 32px;
          background: linear-gradient(135deg, #1a73e8, #4fc3f7);
          color: white;
          border: none;
          border-radius: 50px;
          font-size: 17px;
          font-weight: 700;
          text-decoration: none;
          cursor: pointer;
          box-shadow: 0 6px 24px rgba(26,115,232,0.35);
          transition: all 0.3s;
        }
        .hero-fo-gomb:hover { transform: translateY(-3px); box-shadow: 0 10px 32px rgba(26,115,232,0.45); }
        .hero-masod-gomb {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 16px 32px;
          background: rgba(255,255,255,0.9);
          color: #1a73e8;
          border: 2px solid #1a73e8;
          border-radius: 50px;
          font-size: 17px;
          font-weight: 700;
          text-decoration: none;
          cursor: pointer;
          transition: all 0.3s;
        }
        .hero-masod-gomb:hover { background: #f0f7ff; transform: translateY(-3px); }
        .hero-statisztikak {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 0.75rem;
          margin-top: 0.5rem;
        }
        .hero-stat {
          background: rgba(255,255,255,0.85);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 1rem;
          text-align: center;
          box-shadow: 0 4px 16px rgba(0,0,0,0.06);
          border: 2px solid rgba(255,255,255,0.8);
          transition: all 0.3s;
        }
        .hero-stat:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.1); }
        .hero-stat-ikon { font-size: 26px; margin-bottom: 4px; }
        .hero-stat-szam { font-size: 26px; font-weight: 900; line-height: 1; margin-bottom: 4px; }
        .hero-stat-felirat { font-size: 12px; color: #888; font-weight: 600; }
        .hero-jobb {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.25rem;
          position: relative;
        }
        .hero-kep-keret {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        }
        .hero-kep {
          width: 100%;
          height: auto;
          border-radius: 24px;
          display: block;
          box-shadow: 0 20px 60px rgba(26,115,232,0.15);
          animation: kepLebeg 4s ease-in-out infinite;
        }
        @keyframes kepLebeg {
          0%,100% { transform: translateY(0px); }
          50% { transform: translateY(-14px); }
        }
        .hero-buborek {
          position: absolute;
          background: rgba(255,255,255,0.95);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 10px 18px;
          font-size: 13px;
          font-weight: 700;
          box-shadow: 0 6px 20px rgba(0,0,0,0.12);
          animation: lebeg 3s ease-in-out infinite;
          white-space: nowrap;
          z-index: 2;
        }
        .hero-buborek-1 { top: 10px; right: -10px; color: #1a73e8; border: 2px solid #1a73e8; animation-delay: 0s; }
        .hero-buborek-2 { bottom: 40px; left: -10px; color: #34a853; border: 2px solid #34a853; animation-delay: 1.2s; }
        .hero-buborek-3 { top: 45%; right: -20px; color: #f9ab00; border: 2px solid #f9ab00; animation-delay: 2.2s; }
        @keyframes lebeg {
          0%,100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        .hero-jellemzok {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
          justify-content: center;
        }
        .hero-jellemzo {
          display: flex;
          align-items: center;
          gap: 6px;
          background: rgba(255,255,255,0.85);
          backdrop-filter: blur(10px);
          border-radius: 50px;
          padding: 8px 16px;
          font-size: 13px;
          font-weight: 600;
          color: #333;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          border: 2px solid rgba(255,255,255,0.8);
        }
        .hogyan {
          position: relative;
          z-index: 1;
          padding: 3.5rem 2rem 4rem;
        }
        .hogyan-inner { max-width: min(1200px, 90vw); margin: 0 auto; }
        .hogyan-cim-resz { text-align: center; margin-bottom: 2.5rem; }
        .hogyan-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.8);
          backdrop-filter: blur(10px);
          border: 2px solid #e0e0e0;
          border-radius: 50px;
          padding: 8px 20px;
          font-size: 14px;
          font-weight: 700;
          color: #333;
          margin-bottom: 1rem;
        }
        .hogyan-fo-cim { font-size: 38px; font-weight: 900; color: #1a1a2e; margin: 0 0 0.5rem; }
        .hogyan-alcim { font-size: 17px; color: #666; margin: 0; }
        .hogyan-lepesek { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; }
        .hogyan-kartya {
          background: rgba(255,255,255,0.85);
          backdrop-filter: blur(16px);
          border-radius: 28px;
          padding: 2rem 1.75rem;
          text-align: center;
          border: 2px solid rgba(255,255,255,0.9);
          box-shadow: 0 8px 32px rgba(0,0,0,0.08);
          position: relative;
          transition: all 0.3s;
        }
        .hogyan-kartya:hover { transform: translateY(-8px); box-shadow: 0 20px 50px rgba(0,0,0,0.12); }
        .hogyan-szam {
          position: absolute;
          top: -18px;
          left: 50%;
          transform: translateX(-50%);
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          font-weight: 900;
          color: white;
          box-shadow: 0 4px 16px rgba(0,0,0,0.2);
        }
        .hogyan-ikon {
          width: 76px;
          height: 76px;
          border-radius: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 38px;
          margin: 1rem auto 1rem;
        }
        .hogyan-kartya-cim { font-size: 19px; font-weight: 800; margin-bottom: 0.6rem; }
        .hogyan-kartya-leiras { font-size: 15px; color: #666; line-height: 1.65; margin: 0; }
        .hogyan-nyilak {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 2rem;
          margin-top: 2rem;
        }
        .hogyan-nyil { font-size: 14px; font-weight: 700; color: #999; }
        .hogyan-nyil-jel { font-size: 22px; color: #ddd; }
        @media (max-width: 1024px) {
          .hero-inner { grid-template-columns: 1fr; text-align: center; gap: 1.75rem; padding: 2rem 1.5rem; }
          .hero-bal { align-items: center; }
          .hero-cim { font-size: 38px; }
          .hero-leiras { text-align: center; max-width: 100%; }
          .hero-gombok { justify-content: center; }
          .hero-statisztikak { grid-template-columns: repeat(2, 1fr); }
          .hero-jobb { order: -1; max-width: 440px; margin: 0 auto; width: 100%; }
          .hero-buborek-3 { display: none; }
          .hogyan-lepesek { grid-template-columns: 1fr; max-width: 420px; margin: 0 auto; }
          .hogyan-fo-cim { font-size: 30px; }
          .hogyan-nyilak { flex-direction: column; gap: 0.5rem; }
        }
        @media (max-width: 600px) {
          .hero-inner { padding: 1.5rem 1rem; }
          .hero-cim { font-size: 30px; }
          .hero-leiras { font-size: 16px; }
          .hero-fo-gomb, .hero-masod-gomb { padding: 14px 24px; font-size: 15px; }
          .hero-statisztikak { grid-template-columns: repeat(2, 1fr); gap: 0.75rem; }
          .hero-stat { padding: 1rem; }
          .hero-stat-szam { font-size: 22px; }
          .hero-buborek-1, .hero-buborek-2 { display: none; }
          .hogyan { padding: 2.5rem 1rem 3rem; }
          .hogyan-fo-cim { font-size: 24px; }
        }
      `}</style>

      <div className="fooldal">
        <canvas ref={canvasRef} className="fooldal-canvas"/>

        {/* Hero szekció */}
        <div className="hero">
          <div className="hero-inner">
            <div className="hero-bal">
              <div className="hero-badge"><span>🛡️</span>Magyar Kibervédelmi Oktatás</div>
              <h1 className="hero-cim">Tanulj biztonságosan<br/><span>az interneten!</span></h1>
              <p className="hero-leiras">NetOkos egy magyar nyelvű kiberbiztonsági oktatási platform, amely a gyermekek digitális tudatosságának fejlesztését tűzi ki célul. Az életkorhoz igazított tananyagok, interaktív feladatok és játékos kihívások segítenek biztonságos internetes szokások kialakításában és a felelős online jelenlét elsajátításában.</p>
              <div className="hero-gombok">
                <Link to="/temakork" className="hero-fo-gomb">🚀 Kezdjük el!</Link>
                <Link to="/szuloknek" className="hero-masod-gomb">👨‍👩‍👧 Szülőknek</Link>
              </div>
              <div className="hero-statisztikak">
                {statisztikak.map((s, i) => (
                  <div key={i} className="hero-stat">
                    <div className="hero-stat-ikon">{s.ikon}</div>
                    <div className="hero-stat-szam" style={{color: s.szin}}>{s.szam}</div>
                    <div className="hero-stat-felirat">{s.felirat}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="hero-jobb">
              <div className="hero-kep-keret">
                <img src="/NetOkos_borito.png" alt="NetOkos" className="hero-kep"/>
                <div className="hero-buborek hero-buborek-1">🔒 Biztonságos internet</div>
                <div className="hero-buborek hero-buborek-2">🎮 Interaktív tanulás</div>
                <div className="hero-buborek hero-buborek-3">⭐ +30-60 XP/lecke</div>
              </div>
              <div className="hero-jellemzok">
                {['🌐 6-14 éves korig', '📱 Mobilbarát', '🆓 Teljesen ingyenes', '🇭🇺 Magyar nyelven', '👨‍👩‍👧 Szülővel közösen ajánlott'].map((j, i) => (
                  <div key={i} className="hero-jellemzo">{j}</div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Hogyan működik szekció */}
        <div className="hogyan">
          <div className="hogyan-inner">
            <div className="hogyan-cim-resz">
              <div className="hogyan-badge"><span>🎯</span> Hogyan működik?</div>
              <h2 className="hogyan-fo-cim">Három egyszerű lépés</h2>
              <p className="hogyan-alcim">Így tanul a gyereked a NetOkos segítségével!</p>
            </div>
            <div className="hogyan-lepesek">
              {lepesek.map((lepes, i) => (
                <div key={i} className="hogyan-kartya">
                  <div className="hogyan-szam" style={{background: `linear-gradient(135deg, ${lepes.szin}, ${lepes.szin}bb)`}}>
                    {lepes.szam}
                  </div>
                  <div className="hogyan-ikon" style={{background: lepes.haatter}}>
                    {lepes.ikon}
                  </div>
                  <div className="hogyan-kartya-cim" style={{color: lepes.szin}}>{lepes.cim}</div>
                  <p className="hogyan-kartya-leiras">{lepes.leiras}</p>
                </div>
              ))}
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
}

export default Hero;